export const warehouse = {
    id: '',
    name: '',
    address: '',
    isActive: false,
}